import {observable, computed, action, toJS} from 'mobx';
import moment from 'moment';

export class OfferDetailsForm {
  @observable initialValues = {
    startDate: undefined,
    endDate: undefined,
  };
  @observable dirtyValues = {
    startDate: undefined,
    endDate: undefined,
  };

  @action.bound reset(values) {
    for(let k in values) {
      this.initialValues[k] = values[k];
      this.dirtyValues[k] = values[k];
    }
  }

  @computed get values() {
    return {
      ...toJS(this.initialValues),
      ...toJS(this.dirtyValues),
    }
  }

  @action.bound handleStartEndChange({from, to}) {
    this.newStartDate = from.toISOString();
    this.newEndDate = to.toISOString();
  }

  @action.bound setDateOnly({startDate, endDate}) {
    const mStart = moment(this.newStartDate);
    const mEnd = moment(this.newEndDate);
    const mNewStart = moment(startDate);
    const mNewEnd = moment(endDate);
    mNewStart.set({hour: mStart.hour(), minute: mStart.minute()});
    mNewEnd.set({hour: mEnd.hour(), minute: mEnd.minute()});

    this.newStartDate = mNewStart.toISOString();
    this.newEndDate = mNewEnd.toISOString();
  }

  @action.bound setStartTimeOnly(startTime) {
    const mStart = moment(this.newStartDate);
    const mNewStart = moment(startTime);
    mNewStart.set({year: mStart.year(), month: mStart.month(), day: mStart.day()});
    
    this.newStartDate = mNewStart.toISOString();
  }

  @action.bound setEndTimeOnly(endTime) {
    const mEnd = moment(this.newEndDate);
    const mNewEnd = moment(endTime);
    mNewEnd.set({year: mEnd.year(), month: mEnd.month(), day: mEnd.day()});
    
    this.newEndDate = mNewEnd.toISOString();
  }

  @action.bound setStartDateOnly(startDate) {
    const mStart = moment(this.newStartDate);
    const mNewStart = moment(startDate);
    mNewStart.set({hour: mStart.hour(), minute: mStart.minute(), second: mStart.second()});
    if(mNewStart.isBefore(moment())) {
      return;
    }
    this.newStartDate = mNewStart.toISOString();
    if(mNewStart.isAfter(moment(this.newEndDate))) {
      const mEnd = moment(this.newEndDate);
      const mNewEnd = moment(mNewStart);
      mNewEnd.set({hour: mEnd.hour(), minute: mEnd.minute(), second: mEnd.second()});
      this.newEndDate = mNewEnd.toISOString();
    }
  }

  @action.bound setEndDateOnly(endDate) {
    const mEnd = moment(this.newEndDate);
    const mNewEnd = moment(endDate);
    mNewEnd.set({hour: mEnd.hour(), minute: mEnd.minute(), second: mEnd.second()});
    if(mNewEnd.isBefore(moment(this.newStartDate))) {
      return;
    }    
    this.newEndDate = mNewEnd.toISOString();
  }  

  @action.bound incStartTime(minutes) {
    const mStartDate = moment(this.newStartDate);
    const mEndDate = moment(this.newEndDate);
    const duration = mEndDate.diff(mStartDate, 'minutes');
    const newMStartDate = mStartDate.add({minutes});
    this.newStartDate = newMStartDate.toISOString();
    const newMEndDate = newMStartDate.add(duration, 'minutes');
    this.newEndDate = newMEndDate.toISOString();

    // if(newMStartDate.isBefore(mEndDate)) {
    //   //this.setStartTimeOnly(newMStartDate.toISOString());
    //   this.newStartDate = newMStartDate.toISOString();
    // }
  }

  @action.bound decStartTime(minutes) {
    const mStartDate = moment(this.newStartDate);
    const mEndDate = moment(this.newEndDate);
    const duration = mEndDate.diff(mStartDate, 'minutes');
    const newMStartDate = mStartDate.subtract({minutes});
    this.newStartDate = newMStartDate.toISOString();
    const newMEndDate = newMStartDate.add(duration, 'minutes');
    this.newEndDate = newMEndDate.toISOString();
  }

  @action.bound incEndTime(minutes) {
    const mEndDate = moment(this.newEndDate);
    const newMEndDate = mEndDate.add({minutes});
    this.newEndDate = newMEndDate.toISOString();
  }

  @action.bound decEndTime(minutes) {
    const mStartDate = moment(this.newStartDate);
    const mEndDate = moment(this.newEndDate);
    const newMEndDate = mEndDate.subtract({minutes});
    if(newMEndDate.isAfter(mStartDate)) {
      //this.setEndTimeOnly(newMEndDate.toISOString());
      this.newEndDate = newMEndDate.toISOString();
    }
  }  

  @computed get newStartHours() {
    return moment(this.newStartDate).hours();
  }

  @computed get newStartMinutes() {
    return moment(this.newStartDate).minutes();
  }

  @computed get newEndHours() {
    return moment(this.newEndDate).hours();
  }

  @computed get newEndMinutes() {
    return moment(this.newEndDate).minutes();
  }

  @observable newStartDate;
  @observable newEndDate;

  @action.bound incStartHours(hours) {
    let newStartDate = moment(this.newStartDate);

    const mEndDate = moment(this.newEndDate);
    const duration = mEndDate.diff(newStartDate, 'minutes');    

    newStartDate.hours((newStartDate.hours() + hours) % 24);
    this.newStartDate = newStartDate.toISOString();

    const newEndDate = newStartDate.add(duration, 'minutes');
    this.newEndDate = newEndDate.toISOString();
  }

  @action.bound decStartHours(hours) {
    let newStartDate = moment(this.newStartDate);

    const mEndDate = moment(this.newEndDate);
    const duration = mEndDate.diff(newStartDate, 'minutes');    

    hours = newStartDate.hours() - hours;
    if(hours < 0) hours += 24;
    newStartDate.hours(hours);
    this.newStartDate = newStartDate.toISOString();

    const newEndDate = newStartDate.add(duration, 'minutes');
    this.newEndDate = newEndDate.toISOString();   
  }

  @action.bound incStartMinutes(minutes) {
    let newStartDate = moment(this.newStartDate);
    newStartDate.minutes((newStartDate.minutes() + minutes) % 60);
    this.newStartDate = newStartDate.toISOString();
  }

  @action.bound decStartMinutes(minutes) {
    let newStartDate = moment(this.newStartDate);
    minutes = newStartDate.minutes() - minutes;
    if(minutes < 0) minutes += 60;
    newStartDate.minutes(minutes);
    this.newStartDate = newStartDate.toISOString();
  }


  @action.bound incEndHours(hours) {
    let newEndDate = moment(this.newEndDate);
    newEndDate.hours((newEndDate.hours() + hours) % 24);
    this.newEndDate = newEndDate.toISOString();
  }

  @action.bound decEndHours(hours) {
    let newEndDate = moment(this.newEndDate);
    hours = newEndDate.hours() - hours;
    if(hours < 0) hours += 24;
    newEndDate.hours(hours);
    this.newEndDate = newEndDate.toISOString();
  }

  @action.bound incEndMinutes(minutes) {
    let newEndDate = moment(this.newEndDate);
    newEndDate.minutes((newEndDate.minutes() + minutes) % 60);
    this.newEndDate = newEndDate.toISOString();
  }

  @action.bound decEndMinutes(minutes) {
    let newEndDate = moment(this.newEndDate);
    minutes = newEndDate.minutes() - minutes;
    if(minutes < 0) minutes += 60;
    newEndDate.minutes(minutes);
    this.newEndDate = newEndDate.toISOString();
  }  

  @computed get canApplyNewValues() {
    return (
      this.newStartDate !== this.values.startDate ||
      this.newEndDate !== this.values.endDate
    )
  }

  @action.bound applyNewValues() {
    this.dirtyValues.startDate = this.newStartDate;
    this.dirtyValues.endDate = this.newEndDate;
    if(moment(this.newStartDate).isAfter(moment(this.newEndDate))) {
      this.dirtyValues.startDate = this.newEndDate;
      this.dirtyValues.endDate = this.newStartDate;
    }
    this.initNewValuesFromCurrentValues();
    Object.values(this._valuesChangedListeners).forEach(
      fn => fn(this.dirtyValues.startDate, this.dirtyValues.endDate));
  }

  @action initNewValuesFromCurrentValues() {
    this.newStartDate = this.values.startDate;
    this.newEndDate = this.values.endDate;
  }

  _valuesChangedListeners = {};
  onValuesChanged(fn) {
    let ids = Object.keys(this._valuesChangedListeners);
    let id = ids.length > 0 ? Math.max(...ids) + 1 : 1;
    this._valuesChangedListeners[ids] = fn;
    return () => {
      delete this._valuesChangedListeners[''+id];
    }
  }

  constructor() {
    
  }
} 


// WEBPACK FOOTER //
// ./src/view/OfferDetailsForm.js